import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";
import { PEDIDO } from "./types";

type HistoricoContext = ActionContext<PEDIDO, RootState>;
type HistoricoActionTree = ActionTree<PEDIDO, RootState>;

export const actions: HistoricoActionTree = {
  async listarPedidos(context: HistoricoContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Historico/ListarPedidos",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },

  async listarLineas(context: HistoricoContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Historico/ListarLineas",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },

  //
};
